/**
 * @generated SignedSource<<66e0bc9f4bf04bae26c7b2c4169c95c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportEventsTabStatisticsCardsQuery$variables = {
  id: string;
  startDate?: string | null;
};
export type AdminMembersReportEventsTabStatisticsCardsQuery$data = {
  readonly node: {
    readonly __typename: "OrganizationMembership";
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"MemberReportAverageEventsFeedbackStatisticCardFragment" | "MemberReportConfirmedEventsAttendanceRateStatisticCardFragment" | "MemberReportEventsAttendedStatisticCardFragment" | "MemberReportEventsConfirmationRateStatisticCardFragment">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AdminMembersReportEventsTabStatisticsCardsQuery = {
  response: AdminMembersReportEventsTabStatisticsCardsQuery$data;
  variables: AdminMembersReportEventsTabStatisticsCardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "startDate",
    "variableName": "startDate"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allTime",
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportEventsTabStatisticsCardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportEventsAttendedStatisticCardFragment"
              },
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportConfirmedEventsAttendanceRateStatisticCardFragment"
              },
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportEventsConfirmationRateStatisticCardFragment"
              },
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportAverageEventsFeedbackStatisticCardFragment"
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportEventsTabStatisticsCardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "eventsAttendedReport",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sinceYesterday",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "confirmedEventsAttendanceRateReport",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "eventsConfirmationRateReport",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "AverageEventFeedbackReportResponse",
                "kind": "LinkedField",
                "name": "averageEventsFeedbackReport",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d6f2a69309fef8b1d59585d21c3f57a9",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportEventsTabStatisticsCardsQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportEventsTabStatisticsCardsQuery(\n  $id: ID!\n  $startDate: String\n) {\n  node(id: $id) {\n    __typename\n    ... on OrganizationMembership {\n      id\n      ...MemberReportEventsAttendedStatisticCardFragment_4sOHZa\n      ...MemberReportConfirmedEventsAttendanceRateStatisticCardFragment_4sOHZa\n      ...MemberReportEventsConfirmationRateStatisticCardFragment_4sOHZa\n      ...MemberReportAverageEventsFeedbackStatisticCardFragment_4sOHZa\n    }\n    id\n  }\n}\n\nfragment MemberReportAverageEventsFeedbackStatisticCardFragment_4sOHZa on OrganizationMembership {\n  averageEventsFeedbackReport(startDate: $startDate) {\n    allTime\n  }\n}\n\nfragment MemberReportConfirmedEventsAttendanceRateStatisticCardFragment_4sOHZa on OrganizationMembership {\n  confirmedEventsAttendanceRateReport(startDate: $startDate) {\n    allTime\n  }\n}\n\nfragment MemberReportEventsAttendedStatisticCardFragment_4sOHZa on OrganizationMembership {\n  eventsAttendedReport(startDate: $startDate) {\n    allTime\n    sinceYesterday\n  }\n}\n\nfragment MemberReportEventsConfirmationRateStatisticCardFragment_4sOHZa on OrganizationMembership {\n  eventsConfirmationRateReport(startDate: $startDate) {\n    allTime\n  }\n}\n"
  }
};
})();

(node as any).hash = "94ff523f8c5749cee1fab7cf5b2ffe35";

export default node;
